(function() {
  'use strict';
  
  angular
    .module('plugins.q-and-a')
    .controller('QAndAPollEditController', QAndAPollEditController);
      
  QAndAPollEditController.$inject = [
    '$log', 
    '$scope', 
    'pollPluginService'
  ];
    
  function QAndAPollEditController($log, $scope, pollPluginService) {
    $log = $log.getInstance('QAndAPollEditController');
    
    /* jshint validthis: true */
    var vm = this;
    
    var poll = $scope.poll;
  
    activate();
    
    function activate() {
      poll.name = 'Q&A Session'
      pollPluginService.updatePoll(poll);
    }

  }
})();